module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mdigurp6-089200925edd0c75e1cecb90521f39f9.jpg";